
import details from '@/api/modules/details'
import center from '@/api/modules/center'
import screen from '@/api/modules/screen'
import video from '@/api/modules/video'
import login from '@/api/modules/login'


export default { screen, video,center,details,login }
